//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { EVENTS } from '@/scripts/constants/css-classes'
import {
  ACCOUNT_PANEL,
  HEADER_MINIMUM_Z_INDEX,
  MOBILE_SUBMENU_PANEL,
  OMNICHANNEL,
} from '@/scripts/constants/header'
import { HEADER, MOBILE, TABLET } from '@/scripts/constants/media-query'

export default {
  name: 'rb-header-base-side-panel',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      default: HEADER_MINIMUM_Z_INDEX,
    },
    offsets: {
      type: Object,
      default: () => {
        return {
          navigation: 0,
          messageBar: 48,
        }
      },
    },
    headerIsCollapsed: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: '',
    },
    wcagHiddenButtonIsFocusable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      panelHeight: window.innerHeight,
    }
  },
  computed: {
    isMobile() {
      return this.$mq === MOBILE
    },
    isTablet() {
      return this.$mq === TABLET
    },
    isHeaderMobile() {
      return this.$mq === HEADER
    },
    canShowOverlay() {
      return !this.isMobile
    },
    canShowHeader() {
      return (this.isMobile || this.isTablet || this.isHeaderMobile) && !!this.$slots.header
    },
    panelHeaderIsDisabled() {
      return this.variant === MOBILE_SUBMENU_PANEL
    },
    adjustedTopOffset() {
      if (this.isMobile || this.isTablet || this.isHeaderMobile) {
        if (this.variant === MOBILE_SUBMENU_PANEL && this.headerIsCollapsed) {
          return this.offsets.messageBar
        }
        if (this.variant === OMNICHANNEL || this.variant === MOBILE_SUBMENU_PANEL) {
          return 0
        }
        return this.offsets.navigation
      }

      if (this.variant === OMNICHANNEL) {
        return this.offsets.messageBar
      }

      if (this.variant === ACCOUNT_PANEL) {
        return this.offsets.navigation
      }

      return 0
    },
    adjustedPanelHeight() {
      if (this.isMobile || this.isTablet || this.isHeaderMobile) {
        if (this.variant === OMNICHANNEL || this.variant === MOBILE_SUBMENU_PANEL) {
          return this.headerIsCollapsed
            ? this.panelHeight - (this.offsets.navigation - this.offsets.messageBar)
            : this.panelHeight
        }
        return this.panelHeight - this.offsets.navigation
      }

      if (this.variant === OMNICHANNEL) {
        return this.panelHeight - this.offsets.messageBar
      }

      if (this.variant === ACCOUNT_PANEL) {
        return this.panelHeight - this.offsets.navigation
      }

      return this.panelHeight
    },
    adjustedStyle() {
      return {
        zIndex: this.zIndex + 2,
        height: `${this.adjustedPanelHeight}px`,
        top: `${this.adjustedTopOffset}px`,
      }
    },
    wcagButtonTabIndex() {
      return this.wcagHiddenButtonIsFocusable ? '0' : '-1'
    },
  },
  watch: {
    isOpen(curr, prev) {
      if (prev !== curr) {
        if (curr && this.isMobile) {
          return window.addEventListener(EVENTS.RESIZE, this.updatePanelHeight)
        }

        window.removeEventListener(EVENTS.RESIZE, this.updatePanelHeight)
      }
      this.setTabIndex(curr)
    },
  },
  mounted() {
    this.setTabIndex(this.isOpen)
  },
  methods: {
    emitOverlayClick(setFocus) {
      this.$emit('overlayClicked')
      if (setFocus) {
        document.querySelector('.navigation__logo a').focus()
      }
    },
    emitBack() {
      this.$emit('backClicked')
    },
    emitClose() {
      this.$emit('closeClicked')
    },
    updatePanelHeight() {
      this.panelHeight = window.innerHeight
    },
    setTabIndex(flag) {
      const focusableItems = this.$refs.generalHolder.querySelectorAll('a')
      //for WCAG focus
      if (flag) {
        focusableItems[0].focus()
      }

      focusableItems.forEach((element) => {
        if (flag) {
          element.setAttribute('tabindex', '0')
        } else {
          element.setAttribute('tabindex', '-1')
        }
      })
    },
  },
}
